export default __webpack_public_path__ + "static/media/diamond.98b7fd38.svg";